import { isSameOriginTopWindow } from './isSameOriginTopWindow';

export interface BLKWindow {
	BLK?: { isCwpUserSignedIn: boolean };
}

/**
 * Checks whether the user is logged in to cwp
 */
export const isCwpUserSignedIn = (): boolean => {
	return Boolean(
		((isSameOriginTopWindow() ? top : window) as BLKWindow)?.BLK
			?.isCwpUserSignedIn
	);
};
